import { FormattedMessage } from 'react-intl';
import Box from '@mui/material/Box';
import { ShiftsIcon } from '@atoms/icons';
import { EmptyListPlaceholder } from '@molecules/dataDisplay';
import { DataGrid } from '@molecules/dataDisplay';
import { useLinesOfBusinessSettingsColumns } from './columns';
import { LineOfBusinessListItem } from '@libs/models/linesOfBusiness';
import { useLinesOfBusinessListFilterStore } from '@libs/store/linesOfBusiness';

type StaffingPartnersListPageProps = {
  loading: boolean;
  rows: LineOfBusinessListItem[];
  localizationSubset: string;
};
export function LinesOfBusinessTable({ loading, rows, localizationSubset }: StaffingPartnersListPageProps) {
  const { activeFilters } = useLinesOfBusinessListFilterStore();
  const search = activeFilters.find((f) => f.key === 'search')?.value;

  return (
    <Box sx={{ height: '100%', width: '100%' }}>
      <DataGrid
        rows={rows}
        loading={loading}
        rowHeight={64}
        columns={useLinesOfBusinessSettingsColumns({
          localizationSubset,
        })}
        hideFooter
        filterModel={{
          items: [{ field: 'name', operator: 'contains', value: search }],
        }}
        disableRowSelectionOnClick
        noRowsOverlay={
          <EmptyListPlaceholder
            icon={<ShiftsIcon active />}
            title={<FormattedMessage id={`${localizationSubset}.table.noRows.title`} />}
            subtitle={<FormattedMessage id={`${localizationSubset}.table.noRows.subtitle`} />}
          />
        }
      />
    </Box>
  );
}
